// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDsxRzVC5w0qhXx7y1x5Cfd6OZWg6K7Xoo",
  authDomain: "nasels-blog-203b9.firebaseapp.com",
  projectId: "nasels-blog-203b9",
  storageBucket: "nasels-blog-203b9.appspot.com",
  messagingSenderId: "517108710580",
  appId: "1:517108710580:web:b564cf4255e33a769cabe1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const authConfig = getAuth(app);

export const db = getFirestore(app);
export default app;
